<template>
  <div class="app">
    <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;">
      <el-tab-pane label="Web" name="web" style="height: 100%;">
        <bd-table-web></bd-table-web>
      </el-tab-pane>
      <el-tab-pane label="Uniapp" name="uniapp" style="height: 100%;">
        <bd-table-uniapp></bd-table-uniapp>
      </el-tab-pane>
      <el-tab-pane label="Flutter" name="flutter" style="height: 100%;">
        <bd-table-flutter></bd-table-flutter>
      </el-tab-pane>
      <el-tab-pane label="安卓" name="android" style="height: 100%;">
        <bd-table-android></bd-table-android>
      </el-tab-pane>
      <el-tab-pane label="苹果" name="ios" style="height: 100%;">
        <bd-table-ios></bd-table-ios>
      </el-tab-pane>
      <!--  v-if="showAuthority.debug" -->
      <el-tab-pane label="微信" name="wechat" style="height: 100%;">
        <bd-table-wechat></bd-table-wechat>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BdTableWeb from '@/components/dashboard/main/online/BdTableWeb'
import BdTableUniapp from '@/components/dashboard/main/online/BdTableUniapp'
import BdTableFlutter from '@/components/dashboard/main/online/BdTableFlutter'
import BdTableAndroid from '@/components/dashboard/main/online/BdTableAndroid'
import BdTableIos from '@/components/dashboard/main/online/BdTableIOS'
import BdTableWechat from '@/components/dashboard/main/online/BdTableWechat'

export default {
  name: 'bd-online',
  components: { BdTableWeb, BdTableUniapp, BdTableFlutter, BdTableAndroid, BdTableIos, BdTableWechat },
  data () {
    return {
      activeName: 'web',
      show: false,
    }
  },
  computed: {
    ...mapGetters([ 'showAuthority' ]),
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event)
    }
  }
}
</script>

<style scope>
</style>
